<template>
  <div>

    <v-select v-if="getField(field)" 
    :label="!dense ? getLabel(field) :''" 
    :items="getOptions(field)"
    :disabled="field ? field.DISABLED : false" 
    :rules="getValidators(field)" 
    :value="value" 
    :hint ="field && !dense ? field.HELP: ''"
    :dense="dense"
    @input="updateValue" />




  </div>

</template>

<script>
import fieldMixin from '../mixins/field';


export default {
  name: 'aedSelect',
  mixins: [fieldMixin],
  props: {
    /**
     * Field object containing the configuration for the select box (e.g., options, label).
     * @type {Object}
     */
    field: Object,

    /**
     * The current selected value in the select box.
     * @type {string}
     */
    value: String,
     dense: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      // other data properties...
    };
  },
  mounted() {

    if (this.field && this.field.VALUE) {
      this.updateValue(this.field.VALUE);

    }

  },
  methods: {
    updateValue(newValue) {
      this.$emit('input', newValue);
    },
  },
};
</script>